import { Link } from "react-router-dom";
import Logo from "./Logo";
import { APP_VERSION, APP_BUILD_DATE } from "../version";

/**
 * Shared public-site footer. Branding lockup + four navigation
 * columns. Uses real `Link` components for the in-app destinations
 * (About, How It Works) so navigation stays SPA-fast.
 */
export default function SiteFooter() {
  return (
    <footer className="bg-gray-900 text-white py-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="bg-white/95 rounded-lg p-3 inline-block mb-4">
              <Logo height={28} />
            </div>
            <p className="text-gray-400 mb-4">
              Empowering Canadian professionals with modern job application tools.
            </p>
            <div className="text-gray-400 text-sm">🇨🇦 Made in Canada</div>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/how-it-works" className="hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/signup" className="hover:text-white transition-colors">
                  Resume Builder
                </Link>
              </li>
              <li>
                <Link to="/signup" className="hover:text-white transition-colors">
                  Video Interviews
                </Link>
              </li>
              <li>
                <Link to="/signup" className="hover:text-white transition-colors">
                  QR Integration
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} Inter-View. All rights reserved.
            <span
              className="ml-2 text-gray-600 text-xs font-mono"
              data-testid="app-version-tag"
              title="Live build identifier — bump confirms a fresh deploy"
            >
              · build {APP_VERSION}
              {APP_BUILD_DATE ? ` (${APP_BUILD_DATE})` : ""}
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
